import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHtFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53473)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M49.9999 25H0V9.48271C0 9.00664 0.386034 8.62061 0.862108 8.62061H49.1379C49.614 8.62061 50 9.00664 50 9.48271L49.9999 25Z",
				fill: "#4173CD"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M0 25H49.9999V40.5173C49.9999 40.9933 49.6139 41.3794 49.1378 41.3794H0.862108C0.386034 41.3794 0 40.9933 0 40.5173V25Z",
				fill: "#CD343C"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53473",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgHtFlag);
export { ForwardRef as ReactComponent };
